var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"nav"},[_c('div',{staticClass:"title"},[_c('span',{staticClass:"skip1",on:{"click":function($event){return _vm.toch('/esg')}}},[_vm._v("可持续发展")]),_c('span',[_vm._v("更多")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }